import React, { MouseEvent } from "react";
import cn from "classnames";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";
import { trackEvent } from "../../helpers/analytics";
import { redirect } from "../../helpers/redirect";
import { IContentfulHeroProps } from "../../types/IHero";
import { useReferrerFromCookie } from "../../helpers/landingParams";

import "./style.scss";

const mapColourPresetToButtonColour = {
  white: ButtonColour.Primary,
  "dark-green": ButtonColour.Lime,
  green: ButtonColour.Black,
  "light-green": ButtonColour.Black,
  yellow: ButtonColour.Black,
};

const Hero = ({
  heading1,
  heading2,
  firstCta,
  secondCta,
  disclaimerText,
  colourPreset: colourPresetWithoutDefault,
}: IContentfulHeroProps) => {
  const colourPreset = colourPresetWithoutDefault ?? "light-green";
  const referred = useReferrerFromCookie();
  return (
    <div className={cn("hero", `hero-colour-preset-${colourPreset}`, {
      hero__container_partner: referred,
    })}
    >
      <div className="hero_container">
        {heading1 && <div className="hero_title">{renderRichText(heading1)}</div>}
        {heading2 && <div className="hero_subtitle">{renderRichText(heading2)}</div>}
        <div className="hero_ctas">
          {firstCta && (
          <Button
            size={ButtonSize.Large}
            colour={mapColourPresetToButtonColour[colourPreset] ?? ButtonColour.Primary}
            fixed={false}
            onClick={(e: MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              trackEvent(`hero_clicked_${firstCta.title}`);
              redirect(firstCta.url);
            }}
          >
            {firstCta.title}
          </Button>
          )}
          {secondCta && (
          <Button
            size={ButtonSize.Large}
            colour={mapColourPresetToButtonColour[colourPreset] ?? ButtonColour.Primary}
            fixed={false}
            onClick={(e: MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              trackEvent(`hero_clicked_${secondCta.title}`);
              redirect(secondCta.url);
            }}
          >
            {secondCta.title}
          </Button>
          )}
        </div>
        {disclaimerText && <p className="hero_disclaimer">{renderRichText(disclaimerText)}</p>}
      </div>
    </div>
  );
};

export default Hero;
